import { render, staticRenderFns } from "./recommendation.vue?vue&type=template&id=68245dec&scoped=true&v-if=lang%20%26%26%20__(title)&"
import script from "./recommendation.vue?vue&type=script&lang=js&"
export * from "./recommendation.vue?vue&type=script&lang=js&"
import style0 from "./recommendation.scss?vue&type=style&index=0&id=68245dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68245dec",
  null
  
)

export default component.exports